import React from 'react';

import { Column } from 'app/shopify/components/layout';

import { ButtonDestructive } from './ButtonDestructive';

/** Démo des états du bouton destructive (dont survol et pressé simulés via `state`). */
export function ButtonDestructiveShowcase() {
  return (
    <Column gap="spacing.general.x3" padding="spacing.general.x4">
      <ButtonDestructive label="Click me" size="large" fullWidth />
      <ButtonDestructive label="Destructive — survol (hover)" size="large" state="hover" fullWidth />
      <ButtonDestructive label="Destructive — pressé (pressed)" size="large" state="pressed" fullWidth />
      <ButtonDestructive label="Destructive — focus" size="large" state="focus" fullWidth />
      <ButtonDestructive label="Destructive — désactivé" size="large" state="disabled" fullWidth />
    </Column>
  );
}
